import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InstitutionsInfoListComponent } from './institutions-info-list/institutions-info-list.component';
import { InstitutionsInfoCreateComponent } from './institutions-info-create/institutions-info-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: InstitutionsInfoListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: InstitutionsInfoCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'institutions-info-create/:id',
        component: InstitutionsInfoCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InstitutionsInfoRoutingModule { }
